export const ZH_BOOK_ALIASES = {
  创: ["创世记"],
  出: ["出埃及记"],
  利: ["利未记"],
  民: ["民数记"],
  申: ["申命记"],
  书: ["约书亚记"],
  士: ["士师记"],
  得: ["路得记"],
  得记: ["路得记"],
  撒上: ["撒母耳记上"],
  撒下: ["撒母耳记下"],
  王上: ["列王纪上"],
  王下: ["列王纪下"],
  代上: ["历代志上"],
  代下: ["历代志下"],
  拉: ["以斯拉记"],
  尼: ["尼希米记"],
  斯: ["以斯帖记"],
  伯: ["约伯记"],
  诗: ["诗篇"],
  箴: ["箴言"],
  传: ["传道书"],
  歌: ["雅歌"],
  赛: ["以赛亚书"],
  耶: ["耶利米书"],
  哀: ["耶利米哀歌"],
  结: ["以西结书"],
  但: ["但以理书"],
  何: ["何西阿书"],
  珥: ["约珥书"],
  摩: ["阿摩司书"],
  俄: ["俄巴底亚书"],
  拿: ["约拿书"],
  弥: ["弥迦书"],
  鸿: ["那鸿书"],
  哈: ["哈巴谷书"],
  番: ["西番雅书"],
  该: ["哈该书"],
  亚: ["撒迦利亚书"],
  玛: ["玛拉基书"],
  太: ["马太福音"],
  可: ["马可福音"],
  路: ["路加福音"],
  约: ["约翰福音"],
  徒: ["使徒行传"],
  罗: ["罗马书"],
  林前: ["哥林多前书"],
  林后: ["哥林多后书"],
  加: ["加拉太书"],
  弗: ["以弗所书"],
  腓: ["腓利比书"],
  西: ["歌罗西书"],
  帖前: ["帖撒罗尼迦前书"],
  帖后: ["帖撒罗尼迦后书"],
  提前: ["提摩太前书"],
  提后: ["提摩太后书"],
  多: ["提多书"],
  门: ["腓利门书"],
  来: ["希伯来书"],
  雅: ["雅各书"],
  彼前: ["彼得前书"],
  彼后: ["彼得后书"],
  约一: ["约翰一书"],
  约二: ["约翰二书"],
  约三: ["约翰三书"],
  约壹: ["约翰一书"],
  约贰: ["约翰二书"],
  约叁: ["约翰三书"],
  犹: ["犹大书"],
  启: ["启示录"],
};
